import type React from 'react';

import { TextInput } from 'react-admin';

import type { TextInputProps } from 'react-admin';

export const OrdDescriptionInput = (props: TextInputProps): React.ReactElement => (
  <TextInput multiline minRows={3} {...props} />
);
